import { OptionType } from '@evinced-private/ui-common';

export const INPUT_TYPE = {
	SELECTED_DAY_OF_MONTH: 'selectedDayOfMonth',
	SELECTED_TIME: 'selectedTime',
	SELECTED_TIMEZONE: 'selectedTimezone',
	SELECTED_START_MONTH: 'selectedStartMonth'
} as const;

export type InputType = {
	id: string;
	type: (typeof INPUT_TYPE)[keyof typeof INPUT_TYPE];
	label: string;
	placeholder: string;
	options: OptionType[];
	isSearchable: boolean;
	isMultiple: boolean;
};
